import { useMemo } from "react";
import { useGetChemicalTypes, useGetTransportTypesList } from "../../../../../api/static-data";
import { toLabelMap, toSelectOptions } from "../../shared/utils/staticDataOptions.utils";

/** Fetches chemical-function and transport-type static data and derives the select options + label maps. */
export const useChemicalRecordOptions = () => {
  const { data: chemicalDataType } = useGetChemicalTypes();
  const { data: transportTypeList } = useGetTransportTypesList();

  return useMemo(
    () => ({
      chemFunctionOptions: toSelectOptions(chemicalDataType),
      chemFunctionLabelMap: toLabelMap(chemicalDataType),
      transportOptions: toSelectOptions(transportTypeList),
      transportLabelMap: toLabelMap(transportTypeList)
    }),
    [chemicalDataType, transportTypeList]
  );
};
